<template>
  <div v-if="locationName === '' || locationName == null || false">
    <div class="row">
      <div class="col-12">
        <h5>Dieser Kunde hat keinen Standort.</h5>
        <p>Sie müssen den Standort auswählen, wenn Sie Maßnahmen hinzufügen oder ändern möchten</p>
      </div>
    </div>
  </div>
  <div v-else>
    <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col-12">
          <h6 class="mb-4">Standort: {{ locationName }}</h6>

          <AuditInfo
              :user-role="currentUserRole"
              :created-by-user-data="formData.createdByUserData"
              :created-at="formData.createdAt"
              :updated-by-user-data="formData.updatedByUserData"
              :updated-at="formData.updatedAt"/>

          <div v-if="
              formData.unemployedId === '' ||
              formData.unemployedId == null ||
               false">
            <h6 class="mb-4" style="color: red">{{ $t('general.error') }}</h6>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <SelectVue
              v-model="formData.billingType"
              :options="billingTypeDropdown"
              :required="true"
              label="Art der Abrechnung"
              placeholder="Wählen Sie die Abrechnungsart aus"
              :validation="v$.billingType"
              :messages="v$.billingType.required.$message"
              @update:modelValue="onChangeBillingType"/>
          <Datepicker
              v-model="formData.startDate"
              :required="true"
              label="Start"
              position="down"
              :validation="v$.startDate"
              :messages="v$.startDate.required.$message"/>
          <BaseNumber
              v-model="formData.durationInMonths"
              type="number"
              label="Laufzeit in Mo."
              :required=true
              :validation="v$.durationInMonths"
              :messages="v$.durationInMonths.required.$message"/>
          <SelectVue
              v-model="formData.classification"
              :options="classificationDropdown"
              :is-clear="true"
              :required="true"
              label="Einordnung"
              :validation="v$.classification"
              :messages="v$.classification.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <SelectVue
              v-model="formData.clientId"
              :options="clientDropdown"
              :required="true"
              label="Kostenträger"
              placeholder="Wählen Sie Kostenträger"
              :disabled="isClientIdDisabled"
              :validation="v$.clientId"
              :messages="v$.clientId?.required?.$message"/>
          <Datepicker
              v-model="formData.endDate"
              :required="true"
              label="Ende"
              position="down"
              :validation="v$.endDate"
              :messages="v$.endDate.required.$message"/>
          <BaseNumber
              v-model="formData.unitsInWeek"
              type="number"
              label="FLS pr Wo."
              :required=true
              :decimalPlaces="2"
              :validation="v$.unitsInWeek"
              :messages="v$.unitsInWeek.required.$message"/>
          <div class="text-center">
            <BaseToggle
                v-model="formData.requiresSignature"
                label="Unterschriftspflichtig"/>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <BaseInput
              v-model="formData.clerk"
              label="Sachbearbeiter"/>
          <SelectVue
              v-model="formData.operationType"
              :options="operationTypeDropdown"
              :required="true"
              label="Maßnahmenart"
              :validation="v$.operationType"
              :messages="v$.operationType.required.$message"/>
          <BaseNumber
              v-model="formData.cost"
              type="number"
              label="Umsatz pro Einheit"
              :is-currency="true"
              :required=true
              :decimalPlaces="4"
              :validation="v$.cost"
              :messages="v$.cost.required.$message"/>
          <div class="text-center">
            <BaseToggle
                v-model="formData.digitalSignature"
                label="Digitale Unterschrift"/>
          </div>
        </div>
      </div>

      <div class="row mt-5" style="border-top: 1px solid #D8D8D8">
        <div class="col-12 mt-3 mb-3">Coach</div>
        <div class="col-12">
          <div v-for="(coach, index) in formData.coaches" :key="index" class="mb-2">
            <div class="row me-2">
              <div class="col-lg-3 col-md-4 col-sm-12">
                <SelectVue
                    v-model="coach.type"
                    :options="coachTypeDropdown"
                    :is-clear="true"
                    :required="true"
                    placeholder="Wählen Sie Coach-Typ"
                    :validation="v$.coaches?.$each?.$response?.$data[index]?.type"
                    :messages="v$.coaches?.$each?.$response?.$errors[index]?.type[0]?.$message"/>
              </div>
              <div class="col-lg-8 col-md-7 col-sm-12">
                <SelectVue
                    v-model="coach.coachId"
                    :options="coachDropdown"
                    :is-clear="true"
                    :required="true"
                    placeholder="Wählen Sie Coach"
                    :validation="v$.coaches?.$each?.$response?.$data[index]?.coachId"
                    :messages="v$.coaches?.$each?.$response?.$errors[index]?.coachId[0]?.$message"/>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-12">
                <button class="btn btn-danger ms-2 mb-3" @click.prevent="deleteCoach(index)">
                  <i class="os-icon os-icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-end mt-2">
          <button type="button" class="btn btn-primary" @click.prevent="addCoach">Coach hinzufügen</button>
        </div>
      </div>

      <div class="row mt-5" style="border-top: 1px solid #D8D8D8">
        <div class="col-12 mt-3 mb-3"><h6>Sonderperioden/Anpassung</h6></div>
        <div class="col-12">
          <div v-for="(adjustment, index) in formData.adjustments" :key="index">
            <div class="row d-flex align-items-center mb-2">

              <BaseInput v-model="adjustment.id"
                         hidden="hidden"/>

              <div class="col-4">
                <BaseInput v-model="adjustment.reason"
                           label="Art/Grund"
                           :required=true
                           :validation="v$.adjustments.$each.$response.$data[index]?.reason"
                           :messages="v$.adjustments.$each.$response.$errors[index]?.reason[0]?.$message"/>
              </div>
              <div class="col-2">
                <Datepicker
                    v-model="adjustment.startDate"
                    :required="true"
                    label="Start"
                    position="up"
                    :validation="v$.adjustments.$each.$response.$data[index]?.startDate"
                    :messages="v$.adjustments.$each.$response.$errors[index]?.startDate[0]?.$message"/>
              </div>
              <div class="col-2">
                <Datepicker
                    v-model="adjustment.endDate"
                    :required="true"
                    label="Ende"
                    position="up"
                    :validation="v$.adjustments.$each.$response.$data[index]?.endDate"
                    :messages="v$.adjustments.$each.$response.$errors[index]?.endDate[0]?.$message"/>
              </div>
              <div class="col-2">
                <BaseNumber v-model="adjustment.additionalUnits"
                            label="Dauer in Wochen"
                            :required=true
                            :decimalPlaces="2"
                            :validation="v$.adjustments.$each.$response.$data[index]?.additionalUnits"
                            :messages="v$.adjustments.$each.$response.$errors[index]?.additionalUnits[0]?.$message"/>
              </div>
              <div class="col-2">
                <BaseNumber v-model="adjustment.unitsInWeek"
                            label="FLS Veränderung pro Woche (+/-)"
                            :required=false
                            :min="-1000000"
                            :decimalPlaces="2"
                            :validation="v$.adjustments.$each.$response.$data[index]?.unitsInWeek"
                            :messages="v$.adjustments.$each.$response.$errors[index]?.unitsInWeek[0]?.$message"/>
              </div>
              <button
                  class="btn btn-danger ms-2"
                  v-if="formData.adjustments && formData.adjustments.length > 0"
                  @click.prevent="deleteAdjustment(index)">
                <i class="os-icon os-icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-end">
          <button type="button" class="btn btn-primary" @click.prevent="addAdjustment">
            Fügen Sie spezielle Zeiträume/Anpassungen hinzu
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-center w-100 mt-3">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import assistedLivingCoachingService from '@/api/Unemployed/AssistedLivingCoaching';
import AuditInfo from '@/components/AuditInfo.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseToggle from '@/components/base/BaseToggle.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {getClientByLocationDropdown, getUsersForAssistedLivingCoachingDropdown} from '@/shared/dropdowns';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {helpers} from '@vuelidate/validators';
import {computed, defineEmits, defineProps, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const piniaUserState = piniaUserStore();
const currentUserRole = computed(() => piniaUserState.currentUser?.user?.roles?.[0]);
const {t} = useI18n();
const clientDropdown = ref([]);
const billingTypeDropdown = ref([]);
const operationTypeDropdown = ref([]);
const coachDropdown = ref([]);
const coachTypeDropdown = [
  {
    value: 'specialist',
    label: 'Fachkraft',
  },
  {
    value: 'supervisor',
    label: 'Assistenzkraft',
  },
];

const classificationDropdown = [
  {
    value: 'psyche',
    label: 'Psyche',
  },
  {
    value: 'seeks',
    label: 'Sucht',
  },
];


const isLoaded = ref(false);
const isSubmitting = ref(false);
const isClientIdDisabled = ref(false);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);

const props = defineProps({
  unemployedId: {
    type: Number,
    required: true,
  },
  locationName: {
    type: String,
    required: true,
  },
  locationId: {
    type: Number,
    required: true,
  },
  assistedLivingCoachingId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  unemployedId: props.unemployedId, // !!! IMPORTANT
  specialistId: null,
  supervisorId: null,
  emergencySupervisorId: null,
  clientId: null,
  clerk: '',
  billingType: '',
  operationType: 'assisted_living',
  startDate: '',
  endDate: '',
  durationInMonths: '',
  unitsInWeek: '',
  cost: '',
  requiresSignature: true,
  digitalSignature: true,
  coaches: [],
  adjustments: [],
  classification: ''
});

const formRules = ref({
  unemployedId: requiredRule(t),
  //specialistId: requiredRule(t),
  startDate: requiredRule(t),
  endDate: requiredRule(t),
  billingType: requiredRule(t),
  operationType: requiredRule(t),
  durationInMonths: requiredRule(t),
  unitsInWeek: requiredRule(t),
  cost: requiredRule(t),
  clientId: '',
  classification: requiredRule(t),
  coaches: {
    $each: helpers.forEach({
      coachId: requiredRule(t),
      type: requiredRule(t),
    }),
  },
  adjustments: {
    $each: helpers.forEach({
      reason: requiredRule(t),
      startDate: requiredRule(t),
      endDate: requiredRule(t),
      additionalUnits: requiredRule(t),
      unitsInWeek: requiredRule(t),
      // cost: requiredRule(t),
    }),
  },
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (props.assistedLivingCoachingId) {
      await assistedLivingCoachingService.putAssistedLivingCoaching(
          formData.value, +props.assistedLivingCoachingId,
      );
    } else {
      await assistedLivingCoachingService.postAssistedLivingCoaching(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function addCoach() {
  formData.value.coaches.push({coachId: '', type: ''});
  v$.value.$touch();
}

async function deleteCoach(index) {
  formData.value.coaches.splice(index, 1);
}

async function addAdjustment() {
  formData.value.adjustments.push({
    id: '',
    reason: '',
    startDate: '',
    endDate: '',
    additionalUnits: '',
    unitsInWeek: '',
    cost: '',
  });
  v$.value.$touch();
}

async function deleteAdjustment(index) {
  formData.value.adjustments.splice(index, 1);
}

function addClientToDropdown(clientData, dropdown) {
  if (clientData?.id) {
    const client = {
      label: clientData.name,
      value: clientData.id,
    };
    const exists = dropdown.value.some(item => item.value === client.value);
    if (!exists) {
      dropdown.value.push(client);
    }
  }
}

function addCoachToDropdown(coachData, dropdown) {
  if (coachData?.id) {
    const coach = {
      label: `${coachData.firstName} ${coachData.lastName}`,
      value: coachData.id,
    };
    const exists = dropdown.value.some(item => item.value === coach.value);
    if (!exists) {
      dropdown.value.push(coach);
    }
  }
}

async function applyAssistedLivingCoachingData(data) {
  try {
    const clientId = data.data?.client?.id;
    const billingType = data.data.billingType;
    const operationType = data.data.operationType;
    const coaches = data.data.coaches || [];
    const adjustments = data.data?.adjustments || [];

    // Add client/coach back to dropdown if logically deleted on backend and selected for this coaching
    addClientToDropdown(data.data?.client, clientDropdown);
    coaches.forEach(coach => addCoachToDropdown(coach, coachDropdown));

    const coachesData = coaches.map(coach => ({
      coachId: coach.id,
      type: coach.type,
    }));

    const adjustmentsData = adjustments.map(item => ({
      id: item?.id,
      reason: item.reason,
      startDate: item.startDate,
      endDate: item.endDate,
      additionalUnits: item.additionalUnits,
      unitsInWeek: item.unitsInWeek,
      cost: item.cost,
    }));

    formData.value = {
      ...data.data,
      unemployedId: props.unemployedId,
      clientId: clientId,
      billingType: billingType,
      operationType: operationType,
      coaches: coachesData,
      adjustments: adjustmentsData,
    };

    if (billingType === 'flat_rate_only_final_payment') {
      isClientIdDisabled.value = false;

      formRules.value = {
        ...formRules.value,
        clientId: requiredRule(t),
      };
    } else {
      isClientIdDisabled.value = true;
      formRules.value = {
        ...formRules.value,
        clientId: '',
      };
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeBillingType(billingType) {
  if (billingType === 'flat_rate_only_final_payment') {
    isClientIdDisabled.value = false;
    formData.value.clientId = null;

    formRules.value = {
      ...formRules.value,
      clientId: requiredRule(t),
    };
  } else {
    isClientIdDisabled.value = true;
    formRules.value = {
      ...formRules.value,
      clientId: '',
    };
  }
}

async function getAssistedLivingCoachingEnumsDropdowns() {
  billingTypeDropdown.value = getEnums?.value?.assistedLivingCoachingBillingTypes || [];
  operationTypeDropdown.value = getEnums?.value?.assistedLivingCoachingOperationTypes || [];
}

onMounted(async () => {
  CloseToast();

  // Kick off in parallel with the dropdown loads below - it doesn't depend on them.
  const coachingDataPromise = props.assistedLivingCoachingId
      ? assistedLivingCoachingService.getAssistedLivingCoaching(+props.assistedLivingCoachingId)
      : null;

  await Promise.all([
    getAssistedLivingCoachingEnumsDropdowns(),
    getClientByLocationDropdown(clientDropdown, props.locationId),
    getUsersForAssistedLivingCoachingDropdown(coachDropdown, props.locationId),
  ]);

  if (coachingDataPromise) {
    try {
      const {data} = await coachingDataPromise;
      await applyAssistedLivingCoachingData(data);
    } catch (error) {
      await ErrorToast(error);
    }
  }
  isLoaded.value = true;
});


</script>
<style scoped>

</style>